import React, {Component} from "react";
import ReactDOM from "react-dom";
import * as _ from "lodash";
import {connect} from "react-redux";
import {Route, Switch, NavLink, Redirect} from "react-router-dom";
import {Base, Button} from "zina-dogi-react";
import * as oet from "~/sode/oet/redux";
import * as oet_non_sode from "~/non-sode/oet/redux";
import {SelectItemModal, SAPModalHistory, SelectItemCommentsModal, PoAmendmentModal} from "~/non-sode/oet";
import {SSOTIModal, CommentsModal} from "~/sode/run";
import {Steps} from "~/sode/oet";
import {OETBasicInfo, NonSodeTracker as Basic, ServiceOrderTable, MenuImporters, ScratchPOForm} from "../components";
import swal from "sweetalert";
import {actions as inboxActios, selectors as inboxSelectors} from "../../inbox";
import { utils } from "../../../utils";
// import PartialCancellationTable from "~/components/oet/run/service_order_table/service_order_table.component";

const STATUS = [
    "logistics_oet", // 0
    "project", // 1
    "tcc", // 2
    "fandc", // 3
    "cpm", // 4
    "omc", // 5
    "closed", // 6
    "cancelled" // 7
];

// const GET_STATUS = status => STATUS.indexOf(status);

export class RunDetail extends Component {
    constructor(props) {
        super(props);
        this.pc = React.createRef();
    }

    componentWillMount() {
        this.getComponentData();
    }

    componentDidUpdate(prevProps) {
        const {oetID, runID, non_sode, getNonSodeDetail, oet} = this.props;
        if (prevProps.oetID !== oetID || prevProps.runID !== runID) {
            this.getComponentData(oetID, runID);
        }

        const prevCpoId = prevProps.oet && prevProps.oet.customer_purchase_order
            ? prevProps.oet.customer_purchase_order.id
            : null;
        const currentCpoId = oet && oet.customer_purchase_order ? oet.customer_purchase_order.id : null;

        // Fetch only when the related CPO changes to avoid dispatching on every update.
        if (!non_sode && currentCpoId && prevCpoId !== currentCpoId) {
            getNonSodeDetail(currentCpoId);
        }
    }

    get hasCpo() {
        const {oet} = this.props;
        const noc = oet && oet.hasOwnProperty("customer_purchase_order") && oet.customer_purchase_order;
        return !!noc;
    }

    getComponentData = (oetID = this.props.oetID, runID = this.props.runID) => {
        const {oet, run, getDetails, history, getRunDetail} = this.props;
        const haveOet = !!(oet && oet.id);
        const haveRun = !!(run && run.id);
        const get_run = res => {
            if (!haveRun) {
                getRunDetail(runID, oetID);
            } else if (run.id !== runID) {
                getRunDetail(runID, oetID);
            }
        };
        if (oetID && runID) {
            if (!haveOet) {
                getDetails(oetID, history, runID).then(get_run);
            } else if (oet.id !== oetID) {
                getDetails(oetID, history, runID).then(get_run);
            }
        }
    };

    render() {
        const {oet, run, loading, status, extraProps, user, non_sode, full_user} = this.props;
        let isFoC = false;
        let gr_permissions, cancel_permission, amend_permission = null;
        const cpm_group = full_user.groups.find(item => item.name === 'CPM') || null;
        if (cpm_group){
            gr_permissions = cpm_group.permissions.find(item => item.codename === 'can_create_grn_process')
            cancel_permission = cpm_group.permissions.find(item => item.codename === 'can_cancel_po')
            amend_permission = cpm_group.permissions.find(item => item.codename === 'can_amend_po')
        }
        if (run && run.oet_item && oet && oet.items) {
            const item = oet.items.find(item => parseInt(item.id, 10) === parseInt(run.oet_item, 10));
            isFoC = item ? item.paid_foc === "foc" : false;
        }
        if (status != null) {
            console.group(
                `%c ${status} ${STATUS[status]}`,
                "background: #00f; color: #fff; padding: 8px; border: 1px solid #000; border-left: 4px solid #000;"
            );
        }
        const base_op = {
            className: "run_detail",
            title: `${oet ? `OET #${oet.id_zfill}` : ""} - ${run ? `Run #${run.number}` : ""} ${
                isFoC ? "Free of Charge" : ""
            }`,
            breadcrumbs: [
                {name: "Home", rel: "/", icon: "home"},
                {name: "NON SODE Inbox", rel: "/non-sode/"},
                {
                    name: `NON SODE${this.hasCpo ? ` #${oet.customer_purchase_order.non_sode}` : ""}`,
                    rel: `/non-sode/${this.hasCpo ? oet.customer_purchase_order.id : ""}`
                },
                {
                    name: `OET #${oet ? oet.id_zfill : ""}`,
                    rel: oet ? `/non-sode/oet/${oet.id}/` : null
                },
                {
                    name: `Run #${run ? run.number : ""}`
                }
            ],
            extraProps,
            loading: loading || this.props.oet_non_sode_loading
        };
        console.groupEnd(
            `%c ${status} ${STATUS[status]}`,
            "background: #00f; color: #fff; padding: 8px; border: 1px solid #000; border-left: 4px solid #000;"
        );
        return (
            <div>
                <CommentsModal ref="comment_modal" onSend={this.updateStatus}/>
                <SelectItemModal
                    ref="partial_grn_modal"
                    getData={page => this.props.getSSOTIOnlyParent(oet.id, run.id, page, true)}
                    cancelled={true}
                    onSubmit={this.props.onItemsSelected}
                    runID={this.props.runID}
                    path={'request-grn-job'}
                    title={'GRN process'}
                />
                <SelectItemCommentsModal
                    ref="partial_cancel_po_modal"
                    getData={page => this.props.getSSOTIOnlyParent(oet.id, run.id, page, true)}
                    cancelled={true}
                    onSubmit={this.props.onItemsSelected}
                    runID={this.props.runID}
                    path={'request-cancel-po-job'}
                    title={'Po cancellation'}
                />
                {/* {This is for GRN Reversal and also can be applied to GRN} */}
                <SelectItemModal
                    ref="reverse_grn_modal"
                    getData={page => this.props.getSSOTIOnlyParent(oet.id, run.id, page, true)}
                    cancelled={true}
                    onSubmit={this.props.onItemsSelected}
                    runID={this.props.runID}
                    path={'request-reverse-grn'}
                    title={'Reverse GRN'}
                />
                {status >= 6 && gr_permissions &&(
                    <SAPModalHistory
                        ref="sap_history_modal"
                        cancelled={true}
                        onSubmit={() => this.props.getSAPHistory(this.props.runID)}
                        runID={this.props.runID}
                        status={status}
                    />
                )}
                <SSOTIModal
                    ref="ssoti_modal"
                    getData={page => this.props.getSSOTIOnlyParent(oet.id, run.id, page, true)}
                    cancelled={true}
                />
                <PoAmendmentModal
                    ref="amendment_modal"
                    {...this.props}
                    oet_ssoti={this.props.oet ? this.props.oet.ssoti : null}
                    run={this.props.run}
                    oet={this.props.oet}
                    status={status}
                    non_sode={this.props.non_sode}
                    onSubmit={this.props.onItemsSelected}
                    path={'request-po-amendment'}
                />
                <Base {...base_op}>
                    {run && run.available_status_transitions && this.computeSteps(run.available_status_transitions)}

                    {run && (
                        <Basic
                            ref="basic"
                            oet={oet}
                            run={run}
                            user={user}
                            status={status}
                            nonSode={non_sode}
                            onSubmit={this.onFilter}
                            commentsModal={this.refs.comment_modal}
                            send_create_scratch_po_job={this.props.send_create_scratch_po_job}
                            updatePage={this.getComponentData}
                        />
                    )}
                    {run && run.scratch_po && (
                        <ScratchPOForm onSubmit={this.onFilter} oet={oet} run={run} status={status}/>
                    )}
                    {run && this.computeTabs(
                        this.props.match.url,
                        status, 
                        false, 
                        run.oet_item, 
                        run, 
                        oet, 
                        non_sode, 
                        gr_permissions, 
                        cancel_permission,
                        amend_permission)}
                </Base>
            </div>
        );
    }

    computeTabs = (
        url, 
        status, 
        partially_cancel, 
        itemID = null, 
        run, 
        oet, 
        non_sode, 
        gr_permissions, 
        cancel_permission, 
        amend_permission) => {
        url = url.replace(/\/$/, '');
        return (
        <div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row"
                }}
            >   
                {
                status >= 6 && gr_permissions &&(
                    <React.Fragment>
                        <span style={{ margin: "4px" }} />
                        <Button color="primary" onClick={() => this.onGrnClick(
                            { full: 'Full GRN', partial: 'Partial GRN', reverse: 'Reverse', close: 'close' },
                            this.refs.partial_grn_modal,
                            this.props.onItemsSelected,
                            'request-grn-job',
                            'GRN process'
                        )}>
                            GRN Process
                        </Button>
                    </React.Fragment>
                )}
                {
                status >= 6 && cancel_permission &&(
                    <React.Fragment>
                        <span style={{ margin: "4px" }} />
                        <Button color="primary" onClick={() => this.optionModalChooser(
                            { full: 'Full cancel', partial: 'Partial cancel', close: 'close' },
                            this.refs.partial_cancel_po_modal,
                            this.props.onItemsSelected,
                            'request-cancel-po-job',
                            'Po cancellation'
                        )}>
                            PO Cancellation
                        </Button>
                        
                    </React.Fragment>
                )}
                {status >= 6 && amend_permission &&(
                    <React.Fragment>
                    <span style={{ margin: "4px" }} />
                        <Button color="primary" onClick={this.poAmendment}>
                            PO Amendment
                        </Button>
                    </React.Fragment>
                )}
                {status >= 6 && gr_permissions &&(
                    <React.Fragment>
                        <span style={{ margin: "4px" }} />
                        <Button color="primary" onClick={()=> this.refs.sap_history_modal.open()}>
                            History
                        </Button>
                    </React.Fragment>
                )}
                {/*{partially_cancel && (*/}
                {/*    <React.Fragment>*/}
                {/*        <Button color="primary" onClick={this.onCancelPartial}>*/}
                {/*            Partial Cancellation/Amendment*/}
                {/*        </Button>*/}
                {/*        <span style={{ margin: "4px" }} />*/}
                {/*        <Button color="primary" onClick={() => this.refs.ssoti_modal.open()}>*/}
                {/*            Show Cancel/Amend SSOTI*/}
                {/*        </Button>*/}
                {/*    </React.Fragment>*/}
                {/*)}*/}

                <span style={{flex: "1 1 auto"}}/>
                {this.props.oet && this.props.run && (
                    <div>
                        <MenuImporters
                            runID={this.props.run.id}
                            oetID={this.props.oet.id}
                            run={this.props.run}
                            status={status}
                            oet={this.props.oet}
                        />
                    </div>
                )}
            </div>
            <ul className="nav nav-tabs">
                <li className="nav-item">
                    <NavLink exact to={`${url}`} className="nav-link" activeClassName="active">
                        OET Basic Information
                    </NavLink>
                </li>
                {/*<li className="nav-item">*/}
                {/*    <NavLink*/}
                {/*        exact*/}
                {/*        to={`${url}/table`}*/}
                {/*        className="nav-link"*/}
                {/*        activeClassName="active"*/}
                {/*    >*/}
                {/*        CPO Tracker*/}
                {/*    </NavLink>*/}
                {/*</li>*/}
                {this.projectLinks(url, status)}
                {/*{partially_cancel && (*/}
                {/*    <li className="nav-item">*/}
                {/*        <NavLink exact to={`${url}/partially_cancel`} className="nav-link" activeClassName="active">*/}
                {/*            Partial Cancellation/Amendment*/}
                {/*        </NavLink>*/}
                {/*    </li>*/}
                {/*)}*/}
            </ul>
            <div className="tabs">
                <Switch>
                    <Route
                        exact
                        path={`${url}`}
                        render={props => (
                            <OETBasicInfo
                                {...props}
                                onItemsChange={this.onItemsChange}
                                oet={this.props.oet}
                                status={status}
                                itemID={itemID}
                                nonSode={non_sode}
                            />
                        )}
                    />
                    {/*<Route*/}
                    {/*    exact*/}
                    {/*    path={`${url}/table`}*/}
                    {/*    render={props => (*/}
                    {/*        <TrackerTable*/}
                    {/*            {...props}*/}
                    {/*            onItemsChange={this.onItemsChange}*/}
                    {/*            oet={this.props.oet}*/}
                    {/*            status={status}*/}
                    {/*            itemID={itemID}*/}
                    {/*        />*/}
                    {/*    )}*/}
                    {/*/>*/}
                    {this.projectTabs(url, status)}
                    {/*{partially_cancel && (*/}
                    {/*    <Route*/}
                    {/*        exact*/}
                    {/*        path={`${url}/partially_cancel`}*/}
                    {/*        render={props => (*/}
                    {/*            <PartialCancellationTable*/}
                    {/*                {...props}*/}
                    {/*                ref={this.pc}*/}
                    {/*                getData={(page, site_ids = null, material_type = null) =>*/}
                    {/*                    this.props.getSSOTIOnlyParent(*/}
                    {/*                        oet.id,*/}
                    {/*                        run.id,*/}
                    {/*                        page,*/}
                    {/*                        false,*/}
                    {/*                        site_ids,*/}
                    {/*                        material_type*/}
                    {/*                    )*/}
                    {/*                }*/}
                    {/*                cancelled={false}*/}
                    {/*                onSearchSsotItems={this.onSearchSsotItems}*/}
                    {/*                run={run}*/}
                    {/*                oet={oet}*/}
                    {/*            />*/}
                    {/*        )}*/}
                    {/*    />*/}
                    {/*)}*/}
                    <Redirect to={`${url}`}/>
                </Switch>
            </div>
        </div>
        );
    };

    projectLinks = (url, status) => {
        url = url.replace(/\/$/, '');
        if (status >= 1) {
            return [
                // <li className="nav-item" key="tab-project-1">
                //     <NavLink exact to={`${url}/site`} className="nav-link" activeClassName="active">
                //         Site Creator
                //     </NavLink>
                // </li>,
                <li className="nav-item" key="tab-project-2">
                    <NavLink exact to={`${url}/siteserv`} className="nav-link" activeClassName="active">
                        Service Order
                    </NavLink>
                </li>
            ];
        }
    };

    projectTabs = (url, status) => {
        url = url.replace(/\/$/, '');
        if (status >= 1) {
            return [
                <Route
                    exact
                    key="project-tab-2"
                    path={`${url}/siteserv`}
                    render={props => (
                        <ServiceOrderTable
                            {...props}
                            oet_ssoti={this.props.oet ? this.props.oet.ssoti : null}
                            run={this.props.run}
                            oet={this.props.oet}
                            status={status}
                            loading={true}
                            pagination={{
                                ...this.props.ssoti_pagination,
                                changePage: page =>
                                    this.props.changeSsotiPage(this.props.oet.id, this.props.run.id, page)
                            }}
                        />
                    )}
                />
            ];
        }
    };

    getStepOps = step => {
        let errors = [];
        if (step.conditions_needed) {
            errors = Object.keys(step.conditions_needed).map(key => {
                let error = step.conditions_needed[key];
                if (error.error) {
                    error = error.error;
                }
                if (Array.isArray(error) && error.length === 1) {
                    error = error[0];
                }
                // Temporary this should be review with Cristian Trujillo later
                try {
                    return error.split("_").join(" ");
                } catch (err) {
                    let errors = Object.values(error).map(value => {
                        delete value["id"];
                        return Object.keys(value).map(k => {
                            return `${k.split("_").join(" ")} ${value[k].split("_").join(" ")}`;
                        });
                    });
                    return _.uniqWith(errors, _.isEqual);
                }
            });
        }
        const step_ops = {
            back: step.back,
            display: `Send to ${step.display}`,
            disabled: !step.can_change_status,
            onClick: () => this.openCommentsModalTo(step),
            errors
        };
        switch (step.slug) {
            case "cancelled": {
                return {
                    ...step_ops,
                    display: "Cancel",
                    style: {color: "red"}
                };
            }
            case "to_be_processed_in_sap": {
                return {
                    ...step_ops,
                    display: "Send to  be Processed in SAP"
                };
            }
            case "closed": {
                return {
                    ...step_ops,
                    style: {color: "red"}
                };
            }
            default:
                return step_ops;
        }
    };

    computeSteps = steps => {
        if (steps && steps.length > 0) {
            steps = steps
                .filter(step => step.slug !== "tcc" && step.slug !== "fandc")
                .map(step => this.getStepOps(step));
            return <Steps steps={steps}/>;
        }
    };

    poAmendment = () => {
        swal({
            title: "PO Amendment",
            text: `Please select the process you want to execute`,
            buttons: {amend: "Amend", close:'Close'}
        }).then(willCancel => {
            switch (willCancel) {
                case "amend":
                    this.refs.amendment_modal.open()
                    break;
                case "close":
                    break;
                default:
                    break;
            }
        });
    }
    openCommentsModalTo = step => {
        const modal = this.refs.comment_modal;
        const {runID, user} = this.props;
        modal.toggle({
            requestData: {
                content_type: 21,
                status: step.slug,
                object_id: parseInt(runID),
                user,
                step
            },
            withOnSend: true,
            nextStep: step
        });
    };

    updateStatus = step => {
        const {updateStatus, runID} = this.props;
        updateStatus(
            runID,
            step.slug,
            error => {
                if (error.response) {
                    const status = error.response.status;
                    if (status === 400) {
                        swal({
                            title: "Warning ...",
                            text: `${error.response.data.status}`,
                            icon: "warning",
                            timer: 3000,
                            button: true
                        });
                    }
                }
            },
            run => this.refs.comment_modal.toggle()
        );
    };

    onFilter = ev => {
        this.save(ev);
    };

    save = data => {
        const {oet, run, status, history} = this.props;
        switch (status) {
            case 1: {
                if (data.form === "f&c") {
                    const {saveFandC} = this.props;
                    saveFandC(oet.id, data, history, run.id);
                } else {
                    const {saveSOCountAndVPOCount} = this.props;
                    saveSOCountAndVPOCount(run.id, data).then(run => {
                        swal({
                            title: "Successfully updated!",
                            text: `Run #${run.number}`,
                            icon: "success",
                            timer: 3000,
                            button: true
                        });
                    });
                }
                break;
            }
            case 2: {
                const {saveTCC} = this.props;
                const {for_offer_number_created_in_csp} = data;
                saveTCC(oet.id, for_offer_number_created_in_csp, history, run.id);
                break;
            }
            case 3: {
                const {saveFandC} = this.props;
                saveFandC(oet.id, data, history, run.id);
                break;
            }
            case 4: {
                const {saveCPM} = this.props;
                const {base_id, profit_center} = data;
                saveCPM(oet.id, base_id, history, run.id, profit_center);
                break;
            }
            case 5: {
                const {saveOMC} = this.props;
                const {pr_approved_date} = data;
                saveOMC(oet.id, pr_approved_date, history, run.id);
                break;
            }
            default:
                break;
        }
    };

    onCancelPartial = () => {
        if (this.pc.current) {
            const {idm} = this.pc.current.getSelectedRows();
            const showMesagge = result => {
                if (result) {
                    let wrapper = document.createElement("div");
                    ReactDOM.render(
                        <div>
                            To see it click here:{" "}
                            <Button
                                color="primary"
                                onClick={() => {
                                    document.location = `/run/${result.run.oet_id}/${result.run.id}/`;
                                }}
                            >
                                RUN #{result.run.number}
                            </Button>
                        </div>,
                        wrapper
                    );
                    let el = wrapper.firstChild;
                    swal({
                        title: "A new run has been created",
                        content: el,
                        button: true
                    });
                    this.pc.current.resetSelectedRows();
                    this.pc.current.updateData(1);
                }
            };
            if (idm && idm.length > 0) {
                const {runID} = this.props;
                swal({
                    title: "Partial Cancellation/Amendment",
                    text: `You have selected ${idm.length > 1 ? idm.length : "an"} item${
                        idm.length > 1 ? "s" : ""
                    } to be Canceled/Amend from the existing Run ID.
                    Are you sure to continue?. This operation is not reversible.`,
                    icon: "warning",
                    buttons: {
                        close: "Close",
                        partial_cancel: "Partially Cancel",
                        amend: "Amend"
                    }
                }).then(willCancel => {
                    switch (willCancel) {
                        case "partial_cancel":
                            this.props
                                .onCancelSsotItems(runID, idm, "partial_cancel", this.props.oetID)
                                .then(showMesagge);
                            break;
                        case "amend":
                            this.props.onCancelSsotItems(runID, idm, "amend", this.props.oetID).then(showMesagge);
                            break;
                        default:
                            break;
                    }
                });
            } else {
                swal({
                    title: "Partial Cancellation",
                    text: "You must select the items to cancel",
                    icon: "info",
                    timer: 3000,
                    button: true
                });
            }
        }
    };

    onSearchSsotItems = (items, filter_type = null) => {
        const {runID} = this.props;
        return oet.service.searchSsotItems(runID, items, filter_type);
    };

    getSSOTItems = (oet_id, run_id, page, cancelled) => {
        return oet.service.getSSOTIOET(oet_id, run_id, page, cancelled).then(result => result);
    };

    // THIS IS FOR GRN AND GRN REVERSAL

    onGrnClick = (options, ref, prop, path, title) => {
        const { runID } = this.props;
        const showMesagge = result => {
            if (result) {
                swal({
                    title: result.detail ? "Job sent" : "Error",
                    icon: result.detail ? "success" : "error",
                    text: result.detail ? result.detail : utils.computeError(result),
                    button: true
                });
            }
        };
        swal({
            title: title,
            text: `Please select the process you want to execute`,
            buttons: options
        }).then(willCancel => {
            switch (willCancel) {
                case "partial":
                    ref.open()
                    break;
                case "full":
                    swal({
                        title: title,
                        icon: "warning",
                        text: 'Are you sure you want to continue? This operation is not reversible',
                        buttons: {
                            continue: 'continue', 
                            cancel: 'cancel'
                        }
                    }).then(confirmation => {
                        switch (confirmation) {
                            case 'continue':
                                prop(runID, null, path).then(showMesagge)
                                break;
                            case 'cancel':
                                break;
                            default:
                                break
                        }
                    }  
                    )
                    break;
                case "reverse":
                    this.onGrnClick(
                        { full: 'Full reverse', partial: 'Partial reverse', close: 'close' },
                        this.refs.reverse_grn_modal,
                        this.props.onItemsSelected,
                        'request-reverse-grn',
                        'Reverse GRN'
                    )
                    break;
                default:
                    break;
            }
        });
            
    };
    // THIS IS FOR CANCEL PO
    optionModalChooser = (options, ref, prop, path, title) => {
        const { runID } = this.props;
        let cancellation_input = document.createElement('input');
        cancellation_input.placeholder = 'Cancellation reason'
        const showMesagge = result => {
            if (result) {
                swal({
                    title: result.detail ? "Job sent" : "Error",
                    icon: result.detail ? "success" : "error",
                    text: result.detail ? result.detail : utils.computeError(result),
                    button: true
                });
            }
        };
        swal({
            title: title,
            text: `Please select the process you want to execute`,
            buttons: options
        }).then(willCancel => {
            switch (willCancel) {
                case "partial":
                    ref.open()
                    break;
                case "full":
                    swal({
                        icon: "warning",
                        text: 'Are you sure you want to continue? This operation is not reversible',
                        content: {
                            element: cancellation_input,
                            attributes: {
                              placeholder: title + " reason",
                            },
                          },
                        buttons: {
                            continue: 'continue',
                            cancel: 'cancel'
                        }
                        
                    }).then(option => {
                        switch (option){
                            case 'continue':
                                if (cancellation_input.value === null || cancellation_input.value === ''){
                                    swal({icon: 'error', text: 'You need to type the cancellation reason'});
                                    return false
                                }
                                prop(runID, null, path, cancellation_input.value).then(showMesagge);
                                break;
                            case 'cancel':
                                break;
                            default:
                                break
                        }
                    })
                    break;
                default:
                    break;
            }
        });
            
    }
}

const computeStatus = run => {
    if (run) {
        return run ? STATUS.indexOf(run.status) : null;
    }
};

const mapStateToProps = (store, ownProps) => ({
    non_sode: inboxSelectors.nonSodeSelected(store.non_sode),
    user: store.auth.user.id,
    full_user: store.auth.user,
    oet: store.oet.oetSelected,
    run: store.oet.runSelected,
    oetID: ownProps.match.params.oetID,
    runID: ownProps.match.params.runID,
    loading: store.oet.loading,
    oet_non_sode_loading: store.oet_non_sode.loading,
    site_pagination: store.oet.site_pagination,
    ssoti_pagination: store.oet.ssoti_pagination,
    status: computeStatus(store.oet.runSelected)
});

const mapDispatchToProps = dispatch => ({
    getNonSodeDetail: id => dispatch(inboxActios.getById(id)),
    getDetails: (oetID, history, runID) => {
        return dispatch(oet.actions.getOetInDetail(oetID, history, runID));
    },
    getRunDetail: (runID, oetID) => {
        dispatch(oet.actions.getRunDetail(runID, oetID));
    },
    onCancelSsotItems: (runID, ids, action, oetID) => {
        return dispatch(oet.actions.cancelSsotItems(runID, ids, action, oetID));
    },
    //THIS IS FOR GRN, GRN REVERSAL AND CANCEL PO
    onItemsSelected:(runID, items, path, comment=null) => {
        const data = (comment === null) ? {...items} : {comment: comment} 
        return dispatch (oet_non_sode.actions.send_items_selected_job(runID, data, path))
    },
    getSAPHistory: (runID) => {
        return dispatch (oet_non_sode.actions.get_sap_history(runID))
    },
    getSSOTList: (oetID, runID) => {
        dispatch(oet.actions.getOetSSOTI(oetID, runID));
    },
    updateStatus: (runID, status, onFail = () => {
    }, onSuccess = () => {
    }) => {
        dispatch(oet.actions.updateRun(runID, {status}, onFail, onSuccess));
    },
    saveSOCountAndVPOCount: (
        runID,
        {so_count, vpo_count, for_offer_number_created_in_csp},
        onFail = () => {
        },
        onSuccess = () => {
        }
    ) => {
        return dispatch(
            oet.actions.updateRun(runID, {so_count, vpo_count, for_offer_number_created_in_csp}, onFail, onSuccess)
        );
    },
    saveTCC: (oetID, foncic, history, runID) => {
        dispatch(oet.actions.updateTCC(oetID, foncic, history, runID));
    },
    saveCPM: (oetID, foncic, history, runID, profit_center) => {
        dispatch(oet.actions.updateCPM(oetID, foncic, history, runID, null, profit_center));
    },
    saveOMC: (oetID, pr_approved_date, history, runID) => {
        dispatch(oet.actions.updateOMC(oetID, pr_approved_date, history, runID));
    },
    saveFandC: (oetID, body, history, runID) => {
        dispatch(oet.actions.updateFandC(oetID, body, history, runID));
    },
    syncQuantityContract: (oetID, runID, fn) => {
        dispatch(oet.actions.syncQuantityContract(oetID, runID, fn));
    },
    startPRValidation: (oetID, runID, pr_validation_id, fn) => {
        dispatch(oet.actions.startPRValidation(oetID, runID, pr_validation_id, fn));
    },
    syncWbs: (oetID, runID, fn) => {
        dispatch(oet.actions.syncWbs(oetID, runID, fn));
    },
    syncVoa: (oetID, runID, fn) => {
        dispatch(oet.actions.syncVoa(oetID, runID, fn));
    },
    changeSitesPage: (oetID, runID, page) => {
        dispatch(oet.actions.changeSitesPage(oetID, runID, page));
    },
    changeSsotiPage: (oetID, runID, page) => {
        dispatch(oet.actions.changeSsotiPage(oetID, runID, page));
    },
    getSSOTIOnlyParent: (oetID, runID, page, cancelled, site_ids = null, material_type = null) => {
        return dispatch(oet.actions.getSSOTIOnlyParent(oetID, runID, page, cancelled, site_ids, material_type));
    },
    send_create_scratch_po_job: (run_id, fn) => dispatch(oet_non_sode.actions.send_create_scratch_po_job(run_id, fn))
});

export default connect(mapStateToProps, mapDispatchToProps)(RunDetail);
